import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { FontFamily } from '@ff-os/pdp-shared-redux/slices/fontsSlice';
import { GridGapSizes } from '@ff-os/shared-react/components/grid/Grid';
import { List } from '@ff-os/shared-react/components/list/List';
import { ListItem } from '@ff-os/shared-react/components/list/ListItem';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectFontFamilyById, updateFontFamilyByIds } from '../../_redux';
import { FontFamilyPreview } from './FontFamilyPreview';

const _FontFamilyOptionList = ({
    fontFamilies, selectedFontFamily, gap, commit
}: Props) => (
    <List gap={gap}>
        {fontFamilies.map(f => (
            <ListItem key={f.name}
                bordered={gap !== undefined}
                onClick={() => commit(f)}
                active={f.name === selectedFontFamily?.name}>
                <FontFamilyPreview fontFamily={f.name} />
            </ListItem>
        ))}
    </List>
);

type Props = {
    variableIds: string[];
    fontFamilies: FontFamily[];
    selectedFontFamily: FontFamily;
    commit: (fontFamily: FontFamily) => void;
    gap?: GridGapSizes;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    fontFamilies: selectSortedFonts(state),
    selectedFontFamily: selectFontFamilyById(state, ownProps.variableIds[0]!)!
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    commit: (family: FontFamily) => dispatch(
        updateFontFamilyByIds(ownProps.variableIds, family.name))
});

const selectSortedFonts = createSelector([
    (state: GiftPdpState) => state.fonts.families
], fonts => [...fonts].sort((a, b) => {
    if (a.name < b.name) {
        return -1;
    } else if (a.name > b.name) {
        return 1;
    } else {
        return 0;
    }
}));

export const FontFamilyOptionList = connect(
    mapStateToProps,
    mapDispatchToProps
)(_FontFamilyOptionList);